import request from '@/utils/request'

// 获取所有产品
export function getAllProduct(params) {
  return request({
    url: `/project/index-project`,
    method: 'get',
    params: params
  })
}
// 查询产品
export function getProductByInfo(params) {
  return request({
    url: `project/get-project`,
    method: 'get',
    params: params
  })
}
// 增加产品
export function addProduct(params) {
  return request({
    url: `project/add-project`,
    method: 'post',
    data: params
  })
}
// 编辑产品
export function editProduct(params) {
  return request({
    url: `project/edit-project`,
    method: 'post',
    data: params
  })
}
// 新增产品模块
export function addProductModule(params) {
  return request({
    url: `project/add-project-model`,
    method: 'post',
    data: params
  })
}
// 获取产品模块
export function getProductModule(params) {
  return request({
    url: `project/get-project-model`,
    method: 'get',
    params: params
  })
}

// 获取产品的信息
export function getProductInfo(params) {
  return request({
    url: `project/get-project`,
    method: 'get',
    params: params
  })
}

// 获取产品下拥有的模块列表
export function getProModule(id) {
  return request({
    url: `project/get-project-model`,
    method: 'get',
    params: { project_id: id }
  })
}

// 获取所有模块
export function getAllModules(searchForm) {
  return request({
    url: 'project/get-model',
    method: 'post',
    data: searchForm
  })
}

